import { CORAL_600, GRAY_100, YELLOW_600 } from 'constants/styling/theme'

import { Nullable } from 'models/helpers'

const STAR_GREEN = '#76A470'

/** Returns the star fill color based on the rating value */
export const getStarColor = (value: Nullable<number>): string => {
  if (value === null) return GRAY_100
  if (value && value === 5) return STAR_GREEN
  if (value && value <= 2) return CORAL_600
  return YELLOW_600
}
